import { Container, Row, Col, Button } from "react-bootstrap";
import heroBannerVideo from "../../../assets/images/hero-banner.mp4";
import "./hero.css";

const stats = [
  { value: "120k", label: "Patient Referral" },
  { value: "2k", label: "Doctors Connected" },
  { value: "0.5k", label: "Hospitals Connected" },
];

export const Hero = () => {
  return (
    <section className="hero">
      {/* Background video */}
      <video
        className="hero__video"
        src={heroBannerVideo}
        autoPlay
        muted
        loop
        playsInline
      />

      {/* Overlay */}
      <div className="hero__overlay" />

      {/* Text content */}
      <Container className="hero__content-wrap">
        <Row>
          <Col xs={12} md={7} lg={8} className="hero__content">
            <h1 className="hero__title">
              Where Doctors Collaborate, Patients Thrive
            </h1>
            <p className="hero__subtitle">
              Empowering hospitals, physicians, and patients with real-time
              communication and clinical collaboration—because better care
              starts with better connection.
            </p>
            <Button className="hero__cta">Join Our Network</Button>
          </Col>
        </Row>
      </Container>

      {/* Stats bar */}
      <div className="hero__stats-bar">
        <Container>
          <Row className="justify-content-around align-items-center">
            {stats.map((s, i) => (
              <Col key={s.label} xs={4} className={`hero__stat ${i < stats.length - 1 ? 'hero__stat--divided' : ''}`}>
                <span className="hero__stat-value">{s.value}</span>
                <span className="hero__stat-label">{s.label}</span>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </section>
  );
};
